import React, { useState } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import StatisticsTab from './ReportingComponents/StatisticsTab';
import ReportTab from './ReportingComponents/ReportTab';

const Statistics = () => {
  const [tabIndex, setTabIndex] = useState(0);

  const handleTabChange = (index) => {
    setTabIndex(index);
  };

  return (
    <Tabs selectedIndex={tabIndex} onSelect={handleTabChange} style={{paddingBottom: 72}}>
      <TabList>
        <Tab>Statistics</Tab>
        <Tab>Reports</Tab>
      </TabList>

      <TabPanel>
        <StatisticsTab />
      </TabPanel>
      <TabPanel>
        <ReportTab />
      </TabPanel>
    </Tabs>
  );
}

export default Statistics;